const Error = () => {
    return (
        <div>Error 404 page_not_found</div>
    )
}

export default Error;